export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function post(path, body) {
  const r = await fetch(API + path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body || {}),
  });
  let data = {};
  try { data = await r.json(); } catch (e) { /* empty body */ }
  return { ok: r.ok, status: r.status, data };
}

export async function get(path) {
  const r = await fetch(API + path, { credentials: "include", cache: "no-store" });
  let data = {};
  try { data = await r.json(); } catch (e) { /* empty body */ }
  return { ok: r.ok, status: r.status, data };
}

export function safeNext(n) {
  if (!n || !n.startsWith("/") || n.startsWith("//") || n.includes("\\") || /^\/(auth|api|login)/.test(n)) return "/";
  return n;
}

export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }) + " IST" : "—";
